<template>
  <div
    style="text-align: center; margin-top: 30px; min-height: 450px"
    class="logocontainer"
  >
    <div
      style="max-width: 322px; height: 160px; margin: auto; overflow: hidden"
    >
      <div></div>
    </div>
    <div>
      <img :src="require('@/assets/images/search/360.png')" />
    </div>
    <div style="max-width: 600px; margin: 0 auto auto auto"></div>
    <div style="margin-top: 40px">
      <form @submit.prevent>
        <input
          title="Search"
          name="ss_code"
          maxlength="180"
          id="search"
          placeholder=""
          autofocus=""
          baidusug="1"
          autocomplete="off"
          v-model="searchValue"
          @keyup.enter="searchBtn()"
        />
        <input
        @click.prevent="searchBtn()"
          type="button"
          id="btnSearch"
          value="360搜索"
          style="background: #23ac38;"
        />
      </form>
    </div>
  </div>
</template>

<script>
import "../assets/css/style.css";
import "../assets/css/vendors.css";
import "../assets/css/index.css";
import { logined, agreed, searchBtn, loginOper } from "../assets/js/base";
import { G } from "../assets/js/gamedefault";
import getData from "../components/getData/getData";
export default {
  data() {
    return {
      searchValue: "",
    };
  },
  mounted(){
      document.getElementsByTagName ('html')[0].style.background = "#ffffff"
  },
  methods: {
    searchBtn() {
      let obj = {};
      this.searchValue = this.searchValue.toLocaleLowerCase()
      obj.s = this.searchValue;
      getData.search("search", obj, (res) => {
        if (0 == res.data.code) {
          const _this = this;
          let data = {};
          data.token = res.data.token || "";
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("title", res.data.title);
          getData.postAxiosMethod("auth/verifycode", data, (res2) => {
            _this.yzmId = res2.data.data.Signid;
            _this.yzmImage = res2.data.data.img;

            document.getElementsByTagName("body")[0].className = "Violet";
            document.title = "会员登录";

            if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
              var i = document.createElement("iframe");
              // i.src = '/favicon.ico';
              i.style.display = "none";
              i.onload = function () {
                setTimeout(function () {
                  i.remove();
                }, 9);
              };
              document.body.appendChild(i);
            }
            document.getElementsByTagName ('html')[0].style.background = "#e6e6e6"

            searchBtn();
            this.$router.push("/login");
          });
        } else {
          window.location.href =
            "https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=" +
            this.searchValue;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
a,a:visited,p{color:#999}body{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:12px}a{text-decoration:none}a:hover{text-decoration:underline}
#search{width:68%;height:32px;font-size:20px;max-width:500px;line-height:32px}#btnSearch,.blue{width:120px;font-size:20px}#btnSearch{height:36px}.blue{height:38px}.baidu-box,.bdSug_app,.bdsug_copy{display:none}img{width:300px;border:0}@-webkit-keyframes hvr-wobble-skew{16.65%{-webkit-transform:skew(-12deg);transform:skew(-12deg)}33.3%{-webkit-transform:skew(10deg);transform:skew(10deg)}49.95%{-webkit-transform:skew(-6deg);transform:skew(-6deg)}66.6%{-webkit-transform:skew(4deg);transform:skew(4deg)}83.25%{-webkit-transform:skew(-2deg);transform:skew(-2deg)}100%{-webkit-transform:skew(0);transform:skew(0)}}@keyframes hvr-wobble-skew{16.65%{-webkit-transform:skew(-12deg);transform:skew(-12deg)}33.3%{-webkit-transform:skew(10deg);transform:skew(10deg)}49.95%{-webkit-transform:skew(-6deg);transform:skew(-6deg)}66.6%{-webkit-transform:skew(4deg);transform:skew(4deg)}83.25%{-webkit-transform:skew(-2deg);transform:skew(-2deg)}100%{-webkit-transform:skew(0);transform:skew(0)}}.hvr-wobble-skew{display:inline-block;vertical-align:middle;-webkit-transform:translateZ(0);transform:translateZ(0);box-shadow:0 0 1px transparent;-webkit-backface-visibility:hidden;backface-visibility:hidden;-moz-osx-font-smoothing:grayscale}.hvr-wobble-skew:active,.hvr-wobble-skew:focus,.hvr-wobble-skew:hover{-webkit-animation-name:hvr-wobble-skew;animation-name:hvr-wobble-skew;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-iteration-count:1;animation-iteration-count:1}#search{border:1px solid #b9b9b9;padding:4px 7px;margin:0;height:22px;width:68%;max-width:550px;font:16px arial;background-color:#fff;outline:0}
#btnSearch{    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.16), 0 0 0 1px rgba(0,0,0,0.08);
    border-radius: 2px; width:80px;height:44px;color:#fff;letter-spacing:1px;background:#3385ff;outline:0;-webkit-appearance:none;-webkit-border-radius:0;font-size:14px;padding:0;border:0;cursor:pointer;margin-left:-6px}
#search{
    background-color: transparent;
    margin: 0;
    padding: 4px 10px;
    color: rgba(0,0,0,.87);
    word-wrap: break-word;
    outline: none;
    flex: 100%;
    -webkit-tap-highlight-color: transparent;
    margin-top: -37px;
    font: 16px arial,sans-serif;
    line-height: 34px;
    height: 34px !important;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.16), 0 0 0 1px rgba(0,0,0,0.08);
    border-radius: 2px;
}
#search:hover{
    box-shadow: 0 3px 8px 0 rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.08);
}

body,
html {
  margin: 0;
}
.curr {
  color: #333;
}
select {
  width: 70px;
}
.logocontainer h1 {
  display: inline;
  font-size: 1.6em;
  color: #666;
  text-decoration: none;
  font-weight: 400;
  line-height: 10px;
}
.querybarad {
  width: 100%;
  overflow: hidden;
  margin: 7px auto 0 auto;
  max-width: 640px;
  text-align: left;
}
.NNbdSug_wpr table tr td {
  cursor: pointer;
  line-height: 1.5em;
}
@media screen and (max-width: 640px) {
  .querybarad span {
    display: none;
  }
}
.hotquery {
  width: 800px;
  line-height: 16px;
  overflow: hidden;
  height: 16px;
}
.hotquery a {
  color: #00f;
  display: inline-block;
  margin-right: 15px;
}
.hotquery a:hover {
  color: red;
  text-decoration: none;
}
.ftn {
  text-align: left;
  height: 40px;
  position: fixed;
  bottom: 0;
  padding-left: 10px;
  width: 100%;
  color: #999;
  background: #f2f2f2;
  border-top: 1px solid #e4e4e4;
  line-height: 40px;
  min-width: 980px;
  overflow: hidden;
}
.ftn a {
  display: inline-block;
  margin: 0 8px;
}
.subtitle a {
  text-decoration: underline;
}
</style>
